import { Template } from "./templateApi";
import { Set } from "immutable";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: Set<Template> = Set([]);

export const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    UPDATE_TEMPLATES: (state: any, action: PayloadAction<Template[]>) => {
      if (!action.payload) return state;

      state = Set(action.payload);
      return state;
    },
    ADD_TEMPLATES: (state: any, action: PayloadAction<Template>) => {
      return state.set("", [...state.get(""), action.payload]);
    },
    REMOVE_TEMPLATE_BY_ROOT_UUID: (
      state: Set<Template>,
      action: PayloadAction<{ rootComponentUuid: string }>
    ) => {
      const target = action.payload.rootComponentUuid.trim();
      if (!target) return state;
      return state.filter((t: Template) => {
        const root = t.rootComponentUuid?.trim() ?? "";
        return root !== target;
      }) as Set<Template>;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  UPDATE_TEMPLATES,
  ADD_TEMPLATES,
  REMOVE_TEMPLATE_BY_ROOT_UUID,
} = templateSlice.actions;

export default templateSlice.reducer;
